module.exports = __webpack_public_path__ + "static/media/how-it-works-image.4c0132c1.png";